import axios from 'axios'
import store from '@/store'

const API_REFDATA = process.env.VUE_APP_API_REFDATA
const API_BASE = process.env.VUE_APP_API_BASE

const getPilotSchools = () => {
  const url = `${API_REFDATA}/oes-pilot-schools.json`

  return axios
    .get(url)
    .then((res) => res.data)
    .catch(() => {
      // set error in store & throw exceptions so that it can be propagated to view for handling.
      const error = new Error(
        'Failed to load reference data (oes-pilot-schools.json)'
      )
      store.commit('setError', error)
      throw error
    })
}

const getSchoolCustomisation = (schoolCode) => {
  const url = `${API_REFDATA}/webCustomisation/${schoolCode}-web-customisation.json`

  return axios
    .get(url, { ignoreErrorHandling: true })
    .then((res) => res.data)
    .catch(() => null)
}
const getSchoolsForAddress = (lon, lat) => {
  const catchmentType = 'secondary'
  const academicYear = 7
  const enrolmentYear = new Date().getFullYear() + 1
  const catchmentSchoolsUrl = `${API_BASE}/v1/api/schoolfinder/getCatchmentSchools`
  return axios.get(catchmentSchoolsUrl, {
    params: {
      lon,
      lat,
      catchmentType,
      academicYear,
      enrolmentYear
    }
  })
}

export default {
  getPilotSchools,
  getSchoolsForAddress,
  getSchoolCustomisation
}
